import { TriangleAlert } from "lucide-react";
import { useState } from "react";
import { toast } from "react-toastify";

const ReasonsConfirmModal = ({ isOpen, setMoveModalOpen, onCancel, selectedRow, source, identifier, fetchData, shouldCloseTab = false }) => {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  if (!selectedRow && !identifier) return null;

  const handleMove = () => {
    setError("");

    if (!reason) {
      setError("Please select a reason before moving.");
      return;
    }

    if (reason === "other") {
      if (!customReason.trim()) {
        setError("Please enter a custom reason.");
        return;
      }
      if (customReason.length > 255) {
        setError("Reason must be 255 characters or less.");
        return;
      }
    }

    // console.log({
    //   selectedRow,
    //   reason: reason === "other" ? customReason.trim() : reason,
    // });
    handleUpdateLeadStatus(identifier, 1, reason === "other" ? customReason.trim() : reason);
    setMoveModalOpen(!isOpen);
  };

  const handleUpdateLeadStatus = async (identifier, status, reason_move) => {
    try {
      // console.log("handleUpdateLeadStatus triger for:", selectedRow, identifier, status, reason_move);
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/ispeed_properties/lead-${source}/${identifier}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lead_status: status, reason_move }),
      });

      if (!res.ok) throw new Error("❌ Failed to update lead status");

      // const result = await res.json();
      // console.log("✅ Lead status updated:", result);
      toast.success("Lead Forward to Second List");
      setCustomReason("");
      setReason("");
      if (fetchData) {
        fetchData();
      }
      if (shouldCloseTab) {
        window.close();
      }
    } catch (err) {
      console.error("Error updating lead status:", err);
      toast.error(err.message || "Error Forwarding Lead to Second List");
    }
  };

  return (
    <div className="!fixed !inset-0 !flex !items-center !justify-center !bg-black/50 z-50">
      <div className="!bg-white !rounded-sm !shadow-xl !w-full !max-w-lg">
        <div className="!text-xl !font-normal !text-gray-500 !mb-3 !border-b !border-gray-200 !py-3 !px-6 text-left flex !space-x-2 items-center">
          <TriangleAlert className="text-blue-400" />
          <p>Confirm Move</p>
        </div>

        <div className="!px-6 !py-4">
          <p className="!text-gray-600 !mb-6">Are you sure you want to add this lead to second list?</p>

          <select
            className="!w-full !border !border-gray-300 !rounded-md !px-3 !py-2 !outline-none cursor-pointer"
            value={reason}
            onChange={(e) => {
              setError("");
              setReason(e.target.value);
            }}
          >
            <option className="cursor-pointer" value="" disabled>
              -- Select a reason --
            </option>
            <option className="cursor-pointer" value="Lead not found in machine.">
              Lead was not found in machine
            </option>
            <option className="cursor-pointer" value="Right Person not found.">
              Not found right person
            </option>
            <option className="cursor-pointer" value="Does not qualify">
              Does not qualify
            </option>
            <option className="cursor-pointer" value="Not found right address.">
              Not found right address
            </option>
            <option className="cursor-pointer" value="No match on contact number.">
              No match on contact number
            </option>
            <option className="cursor-pointer" value="Only landline numbers.">
              Only landline numbers
            </option>
            <option className="cursor-pointer" value="other">
              Other
            </option>
          </select>

          {reason === "other" && <textarea className="!w-full !mt-3 !border !border-gray-300 !rounded-md !px-3 !py-2 !outline-none resize-none" rows={3} placeholder="Enter custom reason" value={customReason} maxLength={255} onChange={(e) => setCustomReason(e.target.value)} />}

          {error && <p className="!text-red-500 !text-sm !mt-2">{error}</p>}
        </div>

        <div className="!flex !justify-center !gap-3 !py-3 !px-10">
          <button onClick={onCancel} className="!px-6 !py-2 !rounded-lg !border !border-gray-300 !text-gray-700 hover:!bg-gray-100 !transition cursor-pointer">
            Cancel
          </button>
          <button onClick={handleMove} className="!px-6 !py-2 !rounded-lg !text-white bg-blue-600 hover:bg-blue-700 !transition cursor-pointer">
            Move
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReasonsConfirmModal;
